// import React, { useState, useContext, useEffect } from 'react';
// import { Col, Row, FormGroup, Label } from 'reactstrap';
// import CardWithTitle from 'components/CardWithTitle';
// import ButtonV2 from 'components/common/ButtonV2';
// import EditUploadWrapper from 'components/EditUploadWrapper';
// import S3FileUploadField from 'components/S3FileUploadField';
// import { toast } from 'react-toastify';
// import { axiosGetAPI } from 'services';
// import axios from 'axios';
// import { authContext } from 'contexts/AuthContext';
// import { Download } from 'lucide-react';

// const Uploadpipo = ({ values, setFieldValue }) => {
//   const { auth } = useContext(authContext);
//   const [savePiButtonLoading, setSavePiButtonLoading] = useState(false);
//   const [savePoButtonLoading, setSavePoButtonLoading] = useState(false);
//   const [piFileUrl, setPiFileUrl] = useState(null);
//   const [poFileUrl, setPoFileUrl] = useState(null);
//   const [piDownloadLoading, setPiDownloadLoading] = useState(false);
//   const [poDownloadLoading, setPoDownloadLoading] = useState(false);

//   // Helper function to extract URL from API response
//   const extractFileUrl = (data) => {
//     if (!data) return null;

//     if (typeof data === 'string' && data.startsWith('http')) {
//       return data;
//     }

//     if (typeof data === 'object' && data.data) {
//       return data.data;
//     }

//     if (typeof data === 'string') {
//       try {
//         const parsed = JSON.parse(data);
//         return parsed.data || parsed;
//       } catch (e) {
//         return data;
//       }
//     }

//     return null;
//   };

//   // Helper function to extract file URL from different data types
//   const getFileUrl = (fileData) => {
//     if (!fileData) return '';

//     if (typeof fileData === 'string') {
//       return fileData;
//     }

//     if (Array.isArray(fileData)) {
//       return fileData[0] || '';
//     }

//     if (typeof fileData === 'object') {
//       return fileData.url || fileData.fileUrl || fileData.location || '';
//     }

//     return String(fileData);
//   };

//   // Extract filename from URL
//   const getFileNameFromUrl = (url) => {
//     if (!url || typeof url !== 'string') return '';

//     try {
//       const decodedUrl = decodeURIComponent(url);
//       const urlObj = new URL(decodedUrl);
//       const { pathname } = urlObj;

//       const fileName = pathname.substring(pathname.lastIndexOf('/') + 1);
//       return fileName || '';

//     } catch (error) {
//       try {
//         const parts = url.split('/');
//         const lastPart = parts[parts.length - 1];
//         const cleanName = lastPart.split('?')[0];
//         return decodeURIComponent(cleanName) || '';
//       } catch (e) {
//         return '';
//       }
//     }
//   };

//   const getFileTypeIcon = (fileUrl) => {
//     if (!fileUrl) return '📄';

//     const urlString = getFileUrl(fileUrl);

//     if (urlString.includes('.jpg') || urlString.includes('.jpeg') || urlString.includes('.png')) {
//       return '🖼️';
//     }
//     if (urlString.includes('.pdf')) {
//       return '📕';
//     }
//     if (urlString.includes('.doc') || urlString.includes('.docx')) {
//       return '📘';
//     }

//     return '📄';
//   };

//   // Fetch existing PI file on component mount
//   useEffect(() => {
//     const fetchExistingPiFile = async () => {
//       if (values?.id) {
//         try {
//           const resp = await axiosGetAPI(
//             `${process.env.REACT_APP_REST_API_ENDPOINT}order/${values?.id}/pipo/download?key=PI`,
//             auth
//           );
//           if (resp?.isSuccessful && resp?.data) {
//             const fileUrl = extractFileUrl(resp?.data);
//             setPiFileUrl(fileUrl);
//             setFieldValue('piFile', fileUrl);
//           }
//         } catch (error) {
//           console.error('Error fetching existing PI file:', error);
//         }
//       }
//     };

//     fetchExistingPiFile();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [values?.id, auth]);

//   // Fetch existing PO file on component mount
//   useEffect(() => {
//     const fetchExistingPoFile = async () => {
//       if (values?.id) {
//         try {
//           const resp = await axiosGetAPI(
//             `${process.env.REACT_APP_REST_API_ENDPOINT}order/${values?.id}/pipo/download?key=PO`,
//             auth
//           );
//           if (resp?.isSuccessful && resp?.data) {
//             const fileUrl = extractFileUrl(resp?.data);
//             setPoFileUrl(fileUrl);
//             setFieldValue('poFile', fileUrl);
//           }
//         } catch (error) {
//           console.error('Error fetching existing PO file:', error);
//         }
//       }
//     };

//     fetchExistingPoFile();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [values?.id, auth]);

//   const isFileValid = (file, type) => {
//     if (!file) {
//       toast.error(`Please upload a ${type} file.`);
//       return false;
//     }

//     if (typeof file === 'string' && file.trim() === '') {
//       toast.error(`Please upload a ${type} file.`);
//       return false;
//     }

//     if (Array.isArray(file) && file.length === 0) {
//       toast.error(`Please upload a ${type} file.`);
//       return false;
//     }

//     return true;
//   };

//   const handleSavePI = async () => {
//     if (!isFileValid(values?.piFile, 'PI')) {
//       return;
//     }

//     if (!values?.id) {
//       toast.error('Order ID is missing. Cannot upload file.');
//       return;
//     }

//     // ✅ Clear any existing toasts before starting
//     toast.dismiss();

//     setSavePiButtonLoading(true);
//     try {
//       const fileUrl = getFileUrl(values?.piFile);

//       const url = `${process.env.REACT_APP_REST_API_ENDPOINT}order/update-pipo/${values?.id}?key=PI&url=${encodeURIComponent(fileUrl)}`;

//       const resp = await axios.put(
//         url,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${auth?.data?.token}`,
//             'Content-Type': 'application/json'
//           }
//         }
//       );

//       if (resp?.data?.isSuccessful) {

//         setTimeout(() => {
//           toast.dismiss(); // Clear backend toast
//           toast.success('PI Document Uploaded Successfully', {
//             position: 'top-right',
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//         }, 100);

//         setPiFileUrl(fileUrl);
//         setFieldValue('piFile', fileUrl);
//       } else if (!resp?.data?.isSuccessful && resp?.data?.message) {
//         toast.success(resp?.data?.message);
//       }
//     } catch (error) {
//       console.error('Error while uploading PI file:', error);
//     } finally {
//       setSavePiButtonLoading(false);
//     }
//   };

//   const handleSavePO = async () => {
//     if (!isFileValid(values?.poFile, 'PO')) {
//       return;
//     }

//     if (!values?.id) {
//       toast.error('Order ID is missing. Cannot upload file.');
//       return;
//     }

//     // ✅ Clear any existing toasts before starting
//     toast.dismiss();

//     setSavePoButtonLoading(true);
//     try {
//       const fileUrl = getFileUrl(values?.poFile);

//       const url = `${process.env.REACT_APP_REST_API_ENDPOINT}order/update-pipo/${values?.id}?key=PO&url=${encodeURIComponent(fileUrl)}`;

//       const resp = await axios.put(
//         url,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${auth?.data?.token}`,
//             'Content-Type': 'application/json'
//           }
//         }
//       );

//       if (resp?.data?.isSuccessful) {
//         setTimeout(() => {
//           toast.dismiss(); // Clear backend toast
//           toast.success('PO Document Uploaded Successfully', {
//             position: 'top-right',
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//         }, 100);

//         setPoFileUrl(fileUrl);
//         setFieldValue('poFile', fileUrl);
//       } else if (!resp?.data?.isSuccessful && resp?.data?.message) {
//         toast.success(resp?.data?.message);
//       }
//     } catch (error) {
//       console.error('Error while uploading PO file:', error);
//     } finally {
//       setSavePoButtonLoading(false);
//     }
//   };

//   // ✅ Download PI file - Fixed screen blink issue
//   const handleDownloadPI = async () => {
//     if (!values?.id) {
//       toast.error('Order ID is missing. Cannot download file.');
//       return;
//     }

//     setPiDownloadLoading(true);
//     try {
//       const resp = await axiosGetAPI(
//         `${process.env.REACT_APP_REST_API_ENDPOINT}order/${values?.id}/pipo/download?key=PI`,
//         auth
//       );

//       if (resp?.isSuccessful && resp?.data) {
//         const fileUrl = extractFileUrl(resp.data);

//         if (fileUrl && fileUrl.startsWith('http')) {
//           // ✅ Use window.open instead of anchor tag to prevent blink
//           window.open(fileUrl, '_blank', 'noopener,noreferrer');

//           toast.success('PI Document Downloaded Successfully', {
//             position: 'top-right',
//             autoClose: 2000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//         } else {
//           toast.error('Invalid file URL received.');
//         }
//       } else {
//         toast.error('No PI file available for download.');
//       }
//     } catch (error) {
//       console.error('Error downloading PI file:', error);
//       toast.error('Failed to download PI file. Please try again.');
//     } finally {
//       setPiDownloadLoading(false);
//     }
//   };

//   // ✅ Download PO file - Fixed screen blink issue
//   const handleDownloadPO = async () => {
//     if (!values?.id) {
//       toast.error('Order ID is missing. Cannot download file.');
//       return;
//     }

//     setPoDownloadLoading(true);
//     try {
//       const resp = await axiosGetAPI(
//         `${process.env.REACT_APP_REST_API_ENDPOINT}order/${values?.id}/pipo/download?key=PO`,
//         auth
//       );

//       if (resp?.isSuccessful && resp?.data) {
//         const fileUrl = extractFileUrl(resp.data);

//         if (fileUrl && fileUrl.startsWith('http')) {
//           // ✅ Use window.open instead of anchor tag to prevent blink
//           window.open(fileUrl, '_blank', 'noopener,noreferrer');

//           toast.success('PO Document Downloaded Successfully', {
//             position: 'top-right',
//             autoClose: 2000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//         } else {
//           toast.error('Invalid file URL received.');
//         }
//       } else {
//         toast.error('No PO file available for download.');
//       }
//     } catch (error) {
//       console.error('Error downloading PO file:', error);
//       toast.error('Failed to download PO file. Please try again.');
//     } finally {
//       setPoDownloadLoading(false);
//     }
//   };

//   // Check if files are uploaded or exist
//   const hasPiFile = !!piFileUrl;
//   const hasPoFile = !!poFileUrl;

//   return (
//     <CardWithTitle title="Upload PI/PO">
//       {/* Upload PI Section */}
//       <Row className="mb-3">
//         <Col md={12}>
//           <h6 className="fw-bold mb-3">Upload PI</h6>
//         </Col>
//         <Col md={8}>
//           <FormGroup>
//             <Label className="fw-medium f-12">
//               Select File <span style={{ color: 'red' }}>*</span>
//             </Label>
//             {hasPiFile ? (
//               <EditUploadWrapper
//                 name="piFile"
//                 label="PI File"
//                 fileName={piFileUrl || 'PI File'}
//                 fileIcon={getFileTypeIcon(piFileUrl)}
//                 handleCancel={() => {
//                   setFieldValue('piFile', '');
//                   setPiFileUrl(null);
//                 }}
//                 onClick={handleDownloadPI}
//               />
//             ) : (
//               <S3FileUploadField
//                 label=""
//                 name="piFile"
//                 pathUrl="images/order_logistics/pi_documents"
//                 accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
//                 multiple={false}
//               />
//             )}
//             <small className="text-muted d-block mt-2">
//               Accepted formats: PDF, DOC, DOCX, JPG, PNG (Max 5MB)
//             </small>
//           </FormGroup>
//         </Col>
//         <Col md={4} className="d-flex align-items-end justify-content-end gap-2">
//           <FormGroup className="mb-0">
//             {hasPiFile && (
//               <ButtonV2
//                 color="success"
//                 size="sm"
//                 className="border-radius-4 px-3 me-2"
//                 onClick={handleDownloadPI}
//                 title="Download PI File"
//                 disabled={piDownloadLoading}
//               >
//                 {piDownloadLoading ? '...' : <Download size={16} />}
//               </ButtonV2>
//             )}
//             <ButtonV2
//               color="primary"
//               size="sm"
//               className="border-radius-4 px-4"
//               onClick={handleSavePI}
//               disabled={savePiButtonLoading || !values?.piFile || hasPiFile}
//             >
//               {savePiButtonLoading ? 'Saving...' : 'Save'}
//             </ButtonV2>
//           </FormGroup>
//         </Col>
//       </Row>

//       <hr className="my-4" />

//       {/* Upload PO Section */}
//       <Row className="mb-3">
//         <Col md={12}>
//           <h6 className="fw-bold mb-3">Upload PO</h6>
//         </Col>
//         <Col md={8}>
//           <FormGroup>
//             <Label className="fw-medium f-12">
//               Select File <span style={{ color: 'red' }}>*</span>
//             </Label>
//             {hasPoFile ? (
//               <EditUploadWrapper
//                 name="poFile"
//                 label="PO File"
//                 fileName={poFileUrl || 'PO File'}
//                 fileIcon={getFileTypeIcon(poFileUrl)}
//                 handleCancel={() => {
//                   setFieldValue('poFile', '');
//                   setPoFileUrl(null);
//                 }}
//                 onClick={handleDownloadPO}
//               />
//             ) : (
//               <S3FileUploadField
//                 label=""
//                 name="poFile"
//                 pathUrl="images/order_logistics/po_documents"
//                 accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
//                 multiple={false}
//               />
//             )}
//             <small className="text-muted d-block mt-2">
//               Accepted formats: PDF, DOC, DOCX, JPG, PNG (Max 5MB)
//             </small>
//           </FormGroup>
//         </Col>
//         <Col md={4} className="d-flex align-items-end justify-content-end gap-2">
//           <FormGroup className="mb-0">
//             {hasPoFile && (
//               <ButtonV2
//                 color="success"
//                 size="sm"
//                 className="border-radius-4 px-3 me-2"
//                 onClick={handleDownloadPO}
//                 title="Download PO File"
//                 disabled={poDownloadLoading}
//               >
//                 {poDownloadLoading ? '...' : <Download size={16} />}
//               </ButtonV2>
//             )}
//             <ButtonV2
//               color="primary"
//               size="sm"
//               className="border-radius-4 px-4"
//               onClick={handleSavePO}
//               disabled={savePoButtonLoading || !values?.poFile || hasPoFile}
//             >
//               {savePoButtonLoading ? 'Saving...' : 'Save'}
//             </ButtonV2>
//           </FormGroup>
//         </Col>
//       </Row>
//     </CardWithTitle>
//   );
// };

// export default Uploadpipo;

// Now this was correct code ------------------------------------

import React, { useState, useContext, useEffect, useRef } from 'react';
import { Col, Row, FormGroup, Label } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';
import ButtonV2 from 'components/common/ButtonV2';
import EditUploadWrapper from 'components/EditUploadWrapper';
import S3FileUploadField from 'components/S3FileUploadField';
import { toast } from 'react-toastify';
import axios from 'axios';
import { authContext } from 'contexts/AuthContext';
import { axiosGetAPI } from 'services';
import { Download, Mail } from 'lucide-react';

const ORDER_DOCUMENT_EMAIL_RECIPIENT = 'moin29jna001@gmail.com';

const Uploadpipo = ({ values, setFieldValue }) => {
  const { auth } = useContext(authContext);
  const [piFileUrl, setPiFileUrl] = useState(null);
  const [poFileUrl, setPoFileUrl] = useState(null);
  const [piDownloadLoading, setPiDownloadLoading] = useState(false);
  const [poDownloadLoading, setPoDownloadLoading] = useState(false);
  const [deletingDocument, setDeletingDocument] = useState(null);

  // Refs to track processed files - prevent re-processing same file
  const lastPiFileRef = useRef(null);
  const lastPoFileRef = useRef(null);
  const deletedPiFileRef = useRef(null);
  const deletedPoFileRef = useRef(null);

  // Helper function to extract file URL from different data types
  const getFileUrl = (fileData) => {
    if (!fileData) return '';

    if (typeof fileData === 'string') {
      return fileData;
    }

    if (Array.isArray(fileData)) {
      return fileData[0] || '';
    }

    if (typeof fileData === 'object') {
      if (fileData.data) {
        return getFileUrl(fileData.data);
      }
      return fileData.url || fileData.fileUrl || fileData.location || '';
    }

    return String(fileData);
  };

  const getFileNameFromUrl = (fileUrl, fallbackName) => {
    const resolvedFileUrl = getFileUrl(fileUrl);
    if (!resolvedFileUrl) return fallbackName;

    try {
      const decodedUrl = decodeURIComponent(resolvedFileUrl);
      const sanitizedUrl = decodedUrl.split('?')[0];
      const fileName = sanitizedUrl.substring(
        sanitizedUrl.lastIndexOf('/') + 1,
      );
      return fileName || fallbackName;
    } catch (error) {
      return fallbackName;
    }
  };

  const sanitizeFileName = (fileName, fallbackName) => {
    const sanitizedName = `${fileName || fallbackName || 'document'}`
      .trim()
      .replace(/[\\/:*?"<>|]/g, '_');

    return sanitizedName || fallbackName || 'document';
  };

  const downloadDocumentFile = async (fileUrl, fileName) => {
    const safeFileName = sanitizeFileName(fileName, 'document');

    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
        headers: auth?.data?.token
          ? {
            Authorization: `Bearer ${auth?.data?.token}`,
          }
          : {},
      });

      if (!response.ok) {
        throw new Error('Unable to fetch file.');
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = safeFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.download = safeFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const openDocumentEmailDraft = (documentLabel, fileUrl) => {
    if (!fileUrl) {
      toast.error(`${documentLabel} file is not available for email.`);
      return;
    }

    const fileName = getFileNameFromUrl(
      fileUrl,
      `${documentLabel.toLowerCase()}-order-${values?.id}`,
    );
    const subject = `Order ${values?.id} ${documentLabel} Document`;
    const body = [
      'Hi,',
      '',
      `Please find the ${documentLabel} document for order ${values?.id} below:`,
      '',
      `${fileName}: ${fileUrl}`,
      '',
      'Regards,',
    ].join('\n');

    window.location.href = `mailto:${ORDER_DOCUMENT_EMAIL_RECIPIENT}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;
  };

  const getFileTypeIcon = (fileUrl) => {
    if (!fileUrl) return '📄';

    const urlString = getFileUrl(fileUrl);

    if (
      urlString.includes('.jpg') ||
      urlString.includes('.jpeg') ||
      urlString.includes('.png')
    ) {
      return '🖼️';
    }
    if (urlString.includes('.pdf')) {
      return '📕';
    }
    if (urlString.includes('.doc') || urlString.includes('.docx')) {
      return '📘';
    }

    return '📄';
  };

  // Auto-upload PI file when selected
  useEffect(() => {
    const uploadPiFile = async () => {
      if (!values?.piFile) {
        return;
      }

      const fileUrl = getFileUrl(values?.piFile);

      // Skip if no valid URL or already processed this exact file
      if (
        !fileUrl ||
        fileUrl.trim() === '' ||
        lastPiFileRef.current === fileUrl
      ) {
        return;
      }

      // Mark this file as processed
      lastPiFileRef.current = fileUrl;

      // ✅ IMMEDIATELY show the file in UI
      setPiFileUrl(fileUrl);

      if (!values?.id) {
        toast.error('Order ID is missing. Cannot upload file.');
        return;
      }

      // Upload in background
      toast.dismiss();
      // toast.success('Uploading PI Document Sucessfully...', { autoClose: 2000 });

      try {
        const url = `${process.env.REACT_APP_REST_API_ENDPOINT}order/update-pipo/${values?.id}?key=PI&url=${encodeURIComponent(fileUrl)}`;

        const resp = await axios.put(
          url,
          {},
          {
            headers: {
              Authorization: `Bearer ${auth?.data?.token}`,
              'Content-Type': 'application/json',
            },
          },
        );

        if (resp?.data?.isSuccessful) {
          setTimeout(() => {
            toast.dismiss();
            toast.success('PI Document Uploaded Successfully', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }, 100);
        } else if (!resp?.data?.isSuccessful && resp?.data?.message) {
          toast.success(resp?.data?.message);
        }
      } catch (error) {
        console.error('Error while uploading PI file:', error);
      }
    };

    uploadPiFile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.piFile]);

  // Auto-upload PO file when selected
  useEffect(() => {
    const uploadPoFile = async () => {
      if (!values?.poFile) {
        return;
      }

      const fileUrl = getFileUrl(values?.poFile);

      // Skip if no valid URL or already processed this exact file
      if (
        !fileUrl ||
        fileUrl.trim() === '' ||
        lastPoFileRef.current === fileUrl
      ) {
        return;
      }

      // Mark this file as processed
      lastPoFileRef.current = fileUrl;

      // ✅ IMMEDIATELY show the file in UI
      setPoFileUrl(fileUrl);

      if (!values?.id) {
        toast.error('Order ID is missing. Cannot upload file.');
        return;
      }

      // Upload in background
      toast.dismiss();
      // toast.success('Uploading PO Document Sucessfully...', { autoClose: 2000 });

      try {
        const url = `${process.env.REACT_APP_REST_API_ENDPOINT}order/update-pipo/${values?.id}?key=PO&url=${encodeURIComponent(fileUrl)}`;

        const resp = await axios.put(
          url,
          {},
          {
            headers: {
              Authorization: `Bearer ${auth?.data?.token}`,
              'Content-Type': 'application/json',
            },
          },
        );

        if (resp?.data?.isSuccessful) {
          setTimeout(() => {
            toast.dismiss();
            toast.success('PO Document Uploaded Successfully', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }, 100);
        } else if (!resp?.data?.isSuccessful && resp?.data?.message) {
          toast.success(resp?.data?.message);
        }
      } catch (error) {
        console.error('Error while uploading PO file:', error);
      }
    };

    uploadPoFile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.poFile]);

  // Download PI file
  const handleDownloadPI = async () => {
    if (!piFileUrl) {
      toast.error('PI file is not available for download.');
      return;
    }

    setPiDownloadLoading(true);
    try {
      await downloadDocumentFile(
        piFileUrl,
        getFileNameFromUrl(piFileUrl, `pi-order-${values?.id}`),
      );

      toast.success('PI Document Downloaded Successfully', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      console.error('Error downloading PI file:', error);
      toast.error('Failed to download PI file. Please try again.');
    } finally {
      setPiDownloadLoading(false);
    }
  };

  // Download PO file
  const handleDownloadPO = async () => {
    if (!poFileUrl) {
      toast.error('PO file is not available for download.');
      return;
    }

    setPoDownloadLoading(true);
    try {
      await downloadDocumentFile(
        poFileUrl,
        getFileNameFromUrl(poFileUrl, `po-order-${values?.id}`),
      );

      toast.success('PO Document Downloaded Successfully', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      console.error('Error downloading PO file:', error);
      toast.error('Failed to download PO file. Please try again.');
    } finally {
      setPoDownloadLoading(false);
    }
  };

  const clearDocumentFromUI = (key) => {
    if (key === 'PI') {
      deletedPiFileRef.current = piFileUrl;
      setFieldValue('piFile', '');
      setPiFileUrl(null);
      lastPiFileRef.current = null;
      return;
    }

    deletedPoFileRef.current = poFileUrl;
    setFieldValue('poFile', '');
    setPoFileUrl(null);
    lastPoFileRef.current = null;
  };

  const restoreDocumentInUI = (key, fileUrl) => {
    if (!fileUrl) {
      return;
    }

    if (key === 'PI') {
      deletedPiFileRef.current = null;
      setFieldValue('piFile', fileUrl);
      setPiFileUrl(fileUrl);
      lastPiFileRef.current = fileUrl;
      return;
    }

    deletedPoFileRef.current = null;
    setFieldValue('poFile', fileUrl);
    setPoFileUrl(fileUrl);
    lastPoFileRef.current = fileUrl;
  };

  const handleDeleteDocument = async (key) => {
    if (!values?.id) {
      toast.error('Order ID is missing. Cannot delete file.');
      return;
    }

    const existingFileUrl = key === 'PI' ? piFileUrl : poFileUrl;

    setDeletingDocument(key);
    clearDocumentFromUI(key);

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_REST_API_ENDPOINT}order/delete-pipo/${values.id}?key=${key}`,
        {
          headers: {
            Authorization: `Bearer ${auth?.data?.token}`,
          },
        },
      );
      const responseData = response?.data || {};
      const message = responseData?.message || `${key} file deleted successfully.`;
      const hasSuccessMessage = /removed|deleted|success/i.test(message);
      const isSuccessful =
        responseData?.isSuccessful === true ||
        responseData?.error === false ||
        hasSuccessMessage ||
        (responseData?.isSuccessful === undefined && responseData?.error === undefined);

      if (!isSuccessful || (responseData?.error === true && !hasSuccessMessage)) {
        toast.error(message);
        restoreDocumentInUI(key, existingFileUrl);
        return;
      }

      toast.success(message);
    } catch (error) {
      const responseData = error?.response?.data;
      toast.error(
        responseData?.message || `Failed to delete ${key} file. Please try again.`,
      );
      restoreDocumentInUI(key, existingFileUrl);
      console.error(`Error deleting ${key} file:`, error);
    } finally {
      setDeletingDocument(null);
    }
  };

  const syncExistingDocument = async (key) => {
    if (!values?.id || !auth?.data?.token) {
      return '';
    }

    try {
      const response = await axiosGetAPI(
        `${process.env.REACT_APP_REST_API_ENDPOINT}order/${values?.id}/pipo/download?key=${key}`,
        auth,
      );

      if (!response?.isSuccessful || !response?.data) {
        return;
      }

      const fileUrl = getFileUrl(response?.data);
      if (!fileUrl) {
        return '';
      }

      if (
        (key === 'PI' && deletedPiFileRef.current === fileUrl) ||
        (key === 'PO' && deletedPoFileRef.current === fileUrl)
      ) {
        return '';
      }

      return fileUrl;
    } catch (error) {
      console.error(`Error fetching existing ${key} file:`, error);
      return '';
    }
  };

  useEffect(() => {
    if (piFileUrl) {
      return;
    }

    syncExistingDocument('PI').then((fileUrl) => {
      if (!fileUrl || lastPiFileRef.current === fileUrl) {
        return;
      }

      lastPiFileRef.current = fileUrl;
      setPiFileUrl(fileUrl);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.id, auth]);

  useEffect(() => {
    if (poFileUrl) {
      return;
    }

    syncExistingDocument('PO').then((fileUrl) => {
      if (!fileUrl || lastPoFileRef.current === fileUrl) {
        return;
      }

      lastPoFileRef.current = fileUrl;
      setPoFileUrl(fileUrl);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.id, auth]);

  // Check if files are uploaded or exist
  const hasPiFile = !!piFileUrl;
  const hasPoFile = !!poFileUrl;
  const piFileName = getFileNameFromUrl(piFileUrl, `pi-order-${values?.id}`);
  const poFileName = getFileNameFromUrl(poFileUrl, `po-order-${values?.id}`);

  return (
    <CardWithTitle title="Upload PI/PO">
      {/* Upload PI Section */}
      <Row className="mb-3">
        <Col md={12}>
          <h6 className="fw-bold mb-3">Upload PI</h6>
        </Col>
        <Col md={8}>
          <FormGroup>
            <Label className="fw-medium f-12">Select File</Label>
            {hasPiFile ? (
              <EditUploadWrapper
                name="piFile"
                label="PI File"
                fileName={piFileUrl || 'PI File'}
                fileIcon={getFileTypeIcon(piFileUrl)}
                isLinkPath={!!piFileUrl}
                handleCancel={() => handleDeleteDocument('PI')}
                cancelDisabled={deletingDocument === 'PI'}
                onClick={handleDownloadPI}
              />
            ) : (
              <S3FileUploadField
                label=""
                name="piFile"
                pathUrl="images/order_logistics/pi_documents"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                multiple={false}
              />
            )}
            <small className="text-muted d-block mt-2">
              Accepted formats: PDF, DOC, DOCX, JPG, PNG (Max 5MB)
            </small>
          </FormGroup>
        </Col>
        <Col
          md={4}
          className="d-flex align-items-end justify-content-end gap-2"
        >
          <FormGroup className="mb-0 d-flex gap-2">
            {hasPiFile && (
              <>
                <ButtonV2
                  color="primary"
                  size="sm"
                  className="border-radius-4 px-3"
                  onClick={() => openDocumentEmailDraft('PI', piFileUrl)}
                  title={`Send ${piFileName} via email`}
                >
                  <Mail size={16} />
                </ButtonV2>
                <ButtonV2
                  color="success"
                  size="sm"
                  className="border-radius-4 px-3"
                  onClick={handleDownloadPI}
                  title="Download PI File"
                  disabled={piDownloadLoading}
                >
                  {piDownloadLoading ? '...' : <Download size={16} />}
                </ButtonV2>
              </>
            )}
          </FormGroup>
        </Col>
      </Row>

      <hr className="my-4" />

      {/* Upload PO Section */}
      <Row className="mb-3">
        <Col md={12}>
          <h6 className="fw-bold mb-3">Upload PO</h6>
        </Col>
        <Col md={8}>
          <FormGroup>
            <Label className="fw-medium f-12">Select File</Label>
            {hasPoFile ? (
              <EditUploadWrapper
                name="poFile"
                label="PO File"
                fileName={poFileUrl || 'PO File'}
                fileIcon={getFileTypeIcon(poFileUrl)}
                isLinkPath={!!poFileUrl}
                handleCancel={() => handleDeleteDocument('PO')}
                cancelDisabled={deletingDocument === 'PO'}
                onClick={handleDownloadPO}
              />
            ) : (
              <S3FileUploadField
                label=""
                name="poFile"
                pathUrl="images/order_logistics/po_documents"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                multiple={false}
              />
            )}
            <small className="text-muted d-block mt-2">
              Accepted formats: PDF, DOC, DOCX, JPG, PNG (Max 5MB)
            </small>
          </FormGroup>
        </Col>
        <Col
          md={4}
          className="d-flex align-items-end justify-content-end gap-2"
        >
          <FormGroup className="mb-0 d-flex gap-2">
            {hasPoFile && (
              <>
                <ButtonV2
                  color="primary"
                  size="sm"
                  className="border-radius-4 px-3"
                  onClick={() => openDocumentEmailDraft('PO', poFileUrl)}
                  title={`Send ${poFileName} via email`}
                >
                  <Mail size={16} />
                </ButtonV2>
                <ButtonV2
                  color="success"
                  size="sm"
                  className="border-radius-4 px-3"
                  onClick={handleDownloadPO}
                  title="Download PO File"
                  disabled={poDownloadLoading}
                >
                  {poDownloadLoading ? '...' : <Download size={16} />}
                </ButtonV2>
              </>
            )}
          </FormGroup>
        </Col>
      </Row>
    </CardWithTitle>
  );
};

export default Uploadpipo;
